import { DataGrid, type GridColDef } from 'ui';

import { convertArrayOfObjectsToCsvString, getCurrentTimeFilenameSuffix } from '../../../files';
import { DownloadCSV } from '../DownloadCSV/DownloadCSV';

const CSV_DELIMITER = ',';

const buildDownloadFilename = (filenamePrefix: string) => `${filenamePrefix}-${getCurrentTimeFilenameSuffix()}`;

type OutputDataGridProps<T> = {
  rows: T[];
  columns: Array<GridColDef>;
  rowIdGetter: (row: T) => string;
  filenamePrefix: string;
};

export const OutputDataGridWithDownload = <T,>({
  rows,
  columns,
  rowIdGetter,
  filenamePrefix,
}: OutputDataGridProps<T>) => {
  return (
    <>
      <DataGrid rows={rows} columns={columns} hideFooter={true} getRowId={rowIdGetter} />
      <DownloadCSV
        filename={buildDownloadFilename(filenamePrefix)}
        data={convertArrayOfObjectsToCsvString(rows, CSV_DELIMITER)}
      />
    </>
  );
};
